import React, {PropTypes} from 'react';
import RichTextEditor from 'react-rte';
import './rte-styles.scss';

class RichTextInput extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.updateRich = this.updateRich.bind(this);
  }

  updateRich(value) {
    this.props.onChange(this.props.richName, value);
  }

  render() {
    let wrapperClass = this.props.wrapperClass + " form-group";
    if(this.props.error && this.props.error.lendth > 0) {
      wrapperClass += " " + 'has-error';
    }
    return (
      <div className={wrapperClass}>
        <label htmlFor={this.props.name}>{this.props.label}</label>
        <RichTextEditor
          placeholder={this.props.placeholder}
          value={this.props.value}
          onChange={this.updateRich}/>
        {this.props.error && this.props.error.map((item, index) =>{
          return(<div key={index} className="alert alert-danger alert-sm input-error">{item}</div>);
        })}
      </div>
    );
  }
}

// Note that this odd style is utilized for propType validation for now. Must be defined *after*
// the component is defined, which is why it's separate and down here.
RichTextInput.propTypes = {
  name: PropTypes.string,
  richName: PropTypes.string,
  label: PropTypes.string,
  inputClass: PropTypes.string,
  wrapperClass: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.object,
  error: PropTypes.array,
};

export default RichTextInput;



/** WEBPACK FOOTER **
 ** ./src/components/common/RichTextInput.js
 **/